module.exports = __webpack_public_path__ + "img/img1.d2b4dee0.png";